(function () {
  "use strict";

  var productSelector = '[data-section-type="product"]';

  function dispatchVariantEvent(container, eventName, variant) {
    container.dispatchEvent(
      new CustomEvent(eventName, {
        detail: { variant: variant },
      })
    );
  }

  function syncDetailsAfterVariantChange(container, evt) {
    var variant = evt.detail && evt.detail.variant;
    var isInitialReplay = container.variantDetailSyncReplaying === true;

    if (!variant) {
      return;
    }

    // theme.js updates the variant details synchronously after variantChange.
    // Recheck afterwards so normal changes do not receive duplicate events.
    Promise.resolve().then(function () {
      var skuElement = container.querySelector("[data-sku]");
      var selectedSku = variant.sku || "";

      // On the initial replay currentVariant already matches the checked
      // inputs, so theme.js skips its price equality checks.
      if (isInitialReplay) {
        dispatchVariantEvent(container, "variantPriceChange", variant);
        dispatchVariantEvent(container, "variantUnitPriceChange", variant);
      }

      if (skuElement && skuElement.textContent.trim() !== selectedSku) {
        dispatchVariantEvent(container, "variantSKUChange", variant);
      }
    });
  }

  function getSelectedVariantInput(container) {
    return (
      container.querySelector(
        '[data-field="sizeproducts"] input[data-variant-input]:checked'
      ) ||
      container.querySelector("input[data-variant-input]:checked") ||
      container.querySelector("select[data-variant-input]")
    );
  }

  function replaySelectedVariant(container) {
    if (!container || container.variantDetailSyncReplayed) {
      return;
    }

    var selectedInput = getSelectedVariantInput(container);

    if (!selectedInput) {
      return;
    }

    container.variantDetailSyncReplayed = true;
    container.variantDetailSyncReplaying = true;

    try {
      selectedInput.dispatchEvent(new Event("change", { bubbles: true }));
    } finally {
      container.variantDetailSyncReplaying = false;
    }
  }

  function initContainer(container) {
    if (!container || container.variantDetailSyncInitialized) {
      return;
    }

    container.variantDetailSyncInitialized = true;
    container.addEventListener("variantChange", function (evt) {
      syncDetailsAfterVariantChange(container, evt);
    });
  }

  function forEachProductSection(root, callback) {
    var scope = root || document;

    if (scope.matches && scope.matches(productSelector)) {
      callback(scope);
    }

    if (!scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll(productSelector).forEach(callback);
  }

  function initProductSections(root) {
    forEachProductSection(root, initContainer);
  }

  function initAndReplayProductSections(root) {
    initProductSections(root);
    forEachProductSection(root, replaySelectedVariant);
  }

  initProductSections(document);
  document.addEventListener("page:loaded", function () {
    initAndReplayProductSections(document);
  });
  document.addEventListener("shopify:section:load", function (evt) {
    setTimeout(function () {
      initAndReplayProductSections(evt.target);
    }, 0);
  });
  document.addEventListener("quickview:loaded", function () {
    setTimeout(function () {
      initAndReplayProductSections(document);
    }, 0);
  });

  if (document.readyState === "complete") {
    setTimeout(function () {
      initAndReplayProductSections(document);
    }, 0);
  }
})();
